module.exports = __webpack_public_path__ + "static/media/hen.bfe4716b.png";